/*
 * Funnel Hero — Opt-in form connected to Klaviyo Client Subscriptions API.
 * Endpoint: https://a.klaviyo.com/client/subscriptions/?company_id={publicKey}
 */
(function () {
  if (window.__funnelHeroJsLoaded) return;
  window.__funnelHeroJsLoaded = true;

  var KLAVIYO_REVISION = '2026-04-15';
  var KLAVIYO_ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/';
  var KLAVIYO_PROFILES_ENDPOINT = 'https://a.klaviyo.com/client/profiles/';
  var SUBMIT_TIMEOUT_MS = 10000;
  var PROFILE_TIMEOUT_MS = 4000;
  var ATTRIBUTION_KEY = '_funnelAttribution';
  var ATTRIBUTION_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid'];

  function isValidEmail(s) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(s || '').trim());
  }

  // --- Attribution: capture traffic source and send it to the Klaviyo profile ---
  // Primary source is the URL (utm_* / fbclid), read at submit time. Because the
  // opt-in forms sit on the same page the ad links to, the params are still in the
  // URL when the visitor submits. sessionStorage is only a fallback for the edge
  // case where they navigate away and back before submitting — it can never
  // override a live URL value, and clears when the tab closes so it can't go stale.

  function snapshotFromUrl() {
    var out = {};
    try {
      var qs = new URLSearchParams(window.location.search);
      ATTRIBUTION_FIELDS.forEach(function (key) {
        var v = qs.get(key);
        if (v) out[key] = String(v).slice(0, 200);
      });
    } catch (e) {}
    try {
      var ref = document.referrer || '';
      // Keep only an external referrer; ignore internal navigation between funnel pages.
      if (ref && ref.indexOf('//' + window.location.host) === -1) {
        out.referrer = ref.slice(0, 300);
      }
    } catch (e) {}
    return out;
  }

  function hasKeys(obj) {
    for (var k in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, k)) return true;
    }
    return false;
  }

  // Runs once per page load: remembers the first tagged arrival of this browser
  // session so a later submit still knows the source.
  function captureFirstTouch() {
    var current = snapshotFromUrl();
    if (!hasKeys(current)) return;
    try {
      if (!sessionStorage.getItem(ATTRIBUTION_KEY)) {
        sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(current));
      }
    } catch (e) {}
  }

  // Resolve at submit: live URL wins, else fall back to the stored first touch.
  function resolveAttribution() {
    var current = snapshotFromUrl();
    if (hasKeys(current)) return current;
    try {
      var stored = sessionStorage.getItem(ATTRIBUTION_KEY);
      if (stored) return JSON.parse(stored) || {};
    } catch (e) {}
    return {};
  }

  function deriveTrafficSource(attr) {
    var source = String(attr.utm_source || '').toLowerCase();
    var medium = String(attr.utm_medium || '').toLowerCase();
    if (source === 'meta' && medium === 'paid') return 'Meta Ads';
    if (attr.utm_source || attr.utm_medium) return 'Other Campaign';
    return 'Organic/Other';
  }

  // Best-effort: writes attribution as custom profile properties. Never rejects and
  // has its own short timeout, so it can't block the subscription that follows it.
  function sendProfileProperties(publicKey, email, name, attr) {
    var props = { traffic_source: deriveTrafficSource(attr) };
    ATTRIBUTION_FIELDS.forEach(function (key) {
      if (attr[key]) props[key] = attr[key];
    });
    if (attr.referrer) props.landing_referrer = attr.referrer;

    var attributes = { email: email, properties: props };
    if (name) {
      var parts = name.split(/\s+/);
      attributes.first_name = parts.shift();
      if (parts.length) attributes.last_name = parts.join(' ');
    }

    var url = KLAVIYO_PROFILES_ENDPOINT + '?company_id=' + encodeURIComponent(publicKey);
    var controller = new AbortController();
    var timeoutId = setTimeout(function () {
      try { controller.abort(); } catch (e) {}
    }, PROFILE_TIMEOUT_MS);

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Revision': KLAVIYO_REVISION },
      body: JSON.stringify({ data: { type: 'profile', attributes: attributes } }),
      signal: controller.signal
    })
      .then(function (res) {
        clearTimeout(timeoutId);
        if (!res.ok && res.status !== 202) {
          console.warn('[funnel-hero] profile properties not saved', res.status);
        }
        return res;
      })
      .catch(function (err) {
        clearTimeout(timeoutId);
        console.warn('[funnel-hero] profile properties request failed', err && err.name);
        return null;
      });
  }

  function init(root) {
    if (root.__funnelHeroInit) return;
    root.__funnelHeroInit = true;

    var configEl = document.getElementById(root.dataset.configId);
    if (!configEl) return;

    var config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      console.error('[funnel-hero] invalid config JSON', e);
      return;
    }

    var form = root.querySelector('[data-funnel-form]');
    var nameInput = root.querySelector('[data-funnel-name]');
    var emailInput = root.querySelector('[data-funnel-email]');
    var submitBtn = root.querySelector('[data-funnel-submit]');
    var errorEl = root.querySelector('[data-funnel-error]');
    if (!form || !emailInput || !submitBtn) return;

    var submitting = false;
    var abortController = null;

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.classList.add('is-visible');
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.classList.remove('is-visible');
    }

    function setLoading(state) {
      submitting = state;
      submitBtn.disabled = state;
      submitBtn.classList.toggle('is-loading', state);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (submitting) return;
      clearError();

      var email = (emailInput.value || '').trim();
      var name = nameInput ? (nameInput.value || '').trim() : '';

      if (config.showName && !name) {
        showError(config.messages.missingName);
        if (nameInput) nameInput.classList.add('is-error');
        return;
      }
      if (nameInput) nameInput.classList.remove('is-error');

      if (!isValidEmail(email)) {
        showError(config.messages.invalidEmail);
        emailInput.classList.add('is-error');
        return;
      }
      emailInput.classList.remove('is-error');

      var k = config.klaviyo || {};
      if (!k.publicKey || !k.listId) {
        showError(config.messages.configMissing);
        console.error('[funnel-hero] Klaviyo public key or list id missing');
        return;
      }

      setLoading(true);
      var attribution = resolveAttribution();
      sendProfileProperties(k.publicKey, email, name, attribution)
        .then(function () {
          return submitToKlaviyo(k, email, name, 0);
        })
        .then(function (result) {
          setLoading(false);
          if (result.ok) {
            onSuccess();
          } else {
            var msg = config.messages.serverError;
            if (result.error === 'rate_limited') msg = config.messages.rateLimited;
            showError(msg);
          }
        })
        .catch(function (err) {
          console.error('[funnel-hero] submit error', err);
          setLoading(false);
          showError(config.messages.serverError);
        });
    });

    function onSuccess() {
      showSuccess();
      var redirect = (config.redirectUrl || '').trim();
      if (redirect) {
        setTimeout(function () {
          window.location.href = redirect;
        }, 600);
      }
    }

    function showSuccess() {
      if (errorEl) {
        errorEl.textContent = config.messages.success;
        errorEl.classList.add('is-visible');
        errorEl.style.background = 'rgba(125, 147, 137, 0.92)';
        errorEl.style.color = '#fff';
      }
      submitBtn.disabled = true;
    }

    function submitToKlaviyo(k, email, name, retryCount) {
      var url = KLAVIYO_ENDPOINT + '?company_id=' + encodeURIComponent(k.publicKey);

      var profileAttrs = { email: email };
      if (name) {
        var parts = name.split(/\s+/);
        profileAttrs.first_name = parts.shift();
        if (parts.length) profileAttrs.last_name = parts.join(' ');
      }
      profileAttrs.subscriptions = { email: { marketing: { consent: 'SUBSCRIBED' } } };

      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: config.source || 'Funnel Hero',
            profile: {
              data: {
                type: 'profile',
                attributes: profileAttrs
              }
            }
          },
          relationships: {
            list: { data: { type: 'list', id: k.listId } }
          }
        }
      };

      abortController = new AbortController();
      var timeoutId = setTimeout(function () {
        if (abortController) try { abortController.abort(); } catch (e) {}
      }, SUBMIT_TIMEOUT_MS);

      return fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Revision': KLAVIYO_REVISION
        },
        body: JSON.stringify(body),
        signal: abortController.signal
      })
        .then(function (res) {
          clearTimeout(timeoutId);
          if (res.status === 202) return { ok: true };
          if (res.status === 429) {
            if (retryCount < 2) {
              return new Promise(function (resolve) {
                setTimeout(function () {
                  resolve(submitToKlaviyo(k, email, name, retryCount + 1));
                }, 1500 * Math.pow(2, retryCount));
              });
            }
            return { ok: false, error: 'rate_limited' };
          }
          if (res.status >= 500) {
            console.error('[funnel-hero] Klaviyo server error', res.status);
            if (retryCount < 1) {
              return new Promise(function (resolve) {
                setTimeout(function () {
                  resolve(submitToKlaviyo(k, email, name, retryCount + 1));
                }, 1000);
              });
            }
            return { ok: false, error: 'server' };
          }
          return res.json().then(function (json) {
            var detail = json && json.errors && json.errors[0] && json.errors[0].detail;
            console.error('[funnel-hero] Klaviyo error', res.status, detail || '(no detail)', json);
            return { ok: false, error: detail || 'client_error', status: res.status };
          }).catch(function () {
            console.error('[funnel-hero] Klaviyo response unparseable', res.status);
            return { ok: false, error: 'client_error', status: res.status };
          });
        })
        .catch(function (err) {
          clearTimeout(timeoutId);
          if (err && err.name === 'AbortError') return { ok: false, error: 'timeout' };
          if (retryCount < 1) {
            return new Promise(function (resolve) {
              setTimeout(function () {
                resolve(submitToKlaviyo(k, email, name, retryCount + 1));
              }, 1000);
            });
          }
          return { ok: false, error: 'network' };
        });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-funnel-hero]').forEach(init);
  }

  captureFirstTouch();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    var nodes = e.target.querySelectorAll('[data-funnel-hero]');
    nodes.forEach(init);
  });
})();
